// extracted by mini-css-extract-plugin
module.exports = {"bookContainer":"BookContainer_bookContainer__3iigm","canvasWrapper":"BookContainer_canvasWrapper__3Bhh8","covered":"BookContainer_covered__1KXN4"};